var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTestFailed = function SvgTestFailed(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 8 8",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 0.75,
    d: "M3.353 4 0 7.353.647 8 4 4.647 7.353 8 8 7.353 4.647 4 8 .647 7.353 0 4 3.353.647 0 0 .647z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTestFailed);
export { ForwardRef as ReactComponent };